module.exports = __webpack_public_path__ + "img/collection-weddingRingsStarrySky@2x.5387dd7.jpg";